import { createRouter, createWebHistory } from "vue-router";
import Login from "./components/Login.vue";
import ListaEquipamento from "./components/ListaEquipamento.vue";
import DetalheEquipamento from "./components/DetalheEquipamento.vue";
import ConfigurarVariavel from "./components/ConfigurarVariavel.vue";
import GestaoEnergetica from "./components/gestaoenergetica/GestaoEnergetica.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/listar_equipamentos",
    name: "Lista Equipamentos",
    component: ListaEquipamento,
  },
  {
    path: "/equipamento/:id",
    name: "Dashboard",
    component: DetalheEquipamento,
  },
  {
    path: "/configurar-variaveis/:id",
    name: "Dashboard Variáveis",
    component: ConfigurarVariavel,
  },
  {
    path: "/equipamento/:id/gestaoenergetica",
    name: "GestaoEnergetica",
    component: GestaoEnergetica,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/"
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.name ? `infinity - ${to.name}` : 'infinity';
});

export default router;